import { Button } from '../../components';
import React from 'react';
import { Notification } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchList: any;
  setShowOverlay: any;
}
const NotificationDelete: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchList,
    setShowOverlay,
  } = props;

  const [blocked, setBlocked] = React.useState(false);
  const [hasError, setHasError] = React.useState({
    show: false,
    message: '',
  });
  const sendService = () => {
    setShowOverlay(true);
    Notification.deleteNotification(
      id,
    ).then(() => {
      setShowOverlay(false);
      setBlocked(true);
    }).catch((err: any) => {
      setShowOverlay(false);
      setHasError({
        show: true,
        message: err.response.data.message,
      });
    });
  };

  return (
    <>
      {
        hasError.show ? (
          <>
            <p>{hasError.message}</p>
            <Button onClick={() => {
              handleModalClose();
              fetchList();
            }}
            >
              Ok
            </Button>
          </>
        )
          : (
            <>
              {!blocked ? (
                <>
                  <img src={warning} alt="warning" />
                  <h2>
                    Delete Notification
                  </h2>
                  <p>
                    Are you sure you want to delete this Notification?
                  </p>
                  <div className="modalButtonWrapper">
                    <Button onClick={handleModalClose}>No</Button>
                    <Button intent="danger" onClick={sendService}>Yes</Button>
                  </div>
                </>
              ) : (
                <>
                  <h3>
                    Notification deleted successfully !
                  </h3>
                  <Button onClick={() => {
                    handleModalClose();
                    fetchList();
                  }}
                  >
                    Ok
                  </Button>
                </>
              )}

            </>
          )
      }
    </>
  );
};

export default NotificationDelete;
